<template>
    <div id="userLayout" :class="['user-layout-wrapper', device]">
      <!-- 国际化 -->
      <div class="container">
        <div class="global">
          <a-popover  v-model="visible" placement="bottomRight" title="language" trigger="click">
            <div slot="content">
              <div><a  @click="hide('zh')">Chinese</a></div>
              <div><a  @click="hide('uz')">Uzbek</a></div>
              <div><a  @click="hide('en')">English</a></div>
            </div>
            <a-icon type="global" />
          </a-popover>

        </div>
        <div class="top">
          <div class="header">
            <a href="/">
              <img src="~@/assets/img/png/equick.png" class="logo" alt="logo">
<!--              <span class="title">Logistics</span>-->
            </a>
          </div>
          <div class="desc">
            {{ $t("homeData.indexTitle") }}
          </div>
        </div>

        <router-view></router-view>

        <div class="footer">
          <div class="links">
            <a href="" target="_blank">{{ $t('homeData.assist') }}</a>
            <a href="" target="_blank">{{ $t('homeData.privacy') }}</a>
            <a href="" target="_blank">{{ $t('homeData.clause') }}</a>
          </div>
          <div class="copyright">
            Copyright &copy; 2025 <a href="" target="_blank">{{ $t('homeData.logistics') }}</a> {{ $t('homeData.produce') }}
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
    import RouterView from "@/components/layout/router-view"
    import { mixinDevice } from '@/situation/mixins/index.js'
    import { mapActions } from 'vuex'
    export default {
      name: "UserLayout",
      components: { RouterView },
      mixins: [mixinDevice],
      data () {
        return {
          visible: false,
        }
      },
      methods:{
        ...mapActions(['setLanguage']),
        hide(lang){
          this.setLanguage(lang)
          this.visible = false
        }
      },
      mounted () {
        document.body.classList.add('userLayout')
      },
      beforeDestroy () {
        document.body.classList.remove('userLayout')
      },
    }
  </script>

  <style lang="less" scoped>

    ul{
            padding: 4px;
            list-style-type: none;
            background-color: #ffffff;
            background-clip: padding-box;
            border-radius: 4px;
            outline: none;
            box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
            li{
              color: #1890ff;
              background-color: #e6f7ff;
              clear: both;
              margin: 0;
              padding: 5px 12px;
              font-weight: normal;
              font-size: 14px;
              line-height: 1.5714285714285714;
              cursor: pointer;
              transition: all 0.2s;
              position: relative;
              display: flex;
              align-items: center;
              border-radius: 4px;
              min-width: 160px;
            }
    }

    #userLayout.user-layout-wrapper {
      height: 100%;

      &.mobile {
        .container {
          .main {
            max-width: 368px;
            width: 98%;
          }
        }
      }

      .container {
        width: 100%;
        min-height: 100%;
        background: #f0f2f5 url(~@/assets/img/svg/background.svg) no-repeat 50%;
        background-size: 100%;
        padding: 110px 0 144px;
        position: relative;

        .global{
          position: absolute;
          top: 20px;
          right: 50px;
          font-size: 28px;
          color: #000000a6;
          cursor: pointer;
          }

        a {
          text-decoration: none;
        }

        .top {
          text-align: center;

          .header {
            height: 44px;
            line-height: 44px;

            .badge {
              position: absolute;
              display: inline-block;
              line-height: 1;
              vertical-align: middle;
              margin-left: -12px;
              margin-top: -10px;
              opacity: 0.8;
            }

            .logo {
              height: 44px;
              vertical-align: top;
              margin-right: 16px;
              border-style: none;
            }

            .title {
              font-size: 33px;
              color: rgba(0, 0, 0, .85);
              font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
              font-weight: 600;
              position: relative;
              top: 2px;
            }
          }
          .desc {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
            margin-top: 12px;
            margin-bottom: 40px;
          }
        }

        .main {
          min-width: 260px;
          width: 368px;
          margin: 0 auto;
        }

        .footer {
          position: absolute;
          width: 100%;
          bottom: 0;
          padding: 0 16px;
          margin: 48px 0 24px;
          text-align: center;

          .links {
            margin-bottom: 8px;
            font-size: 14px;
            a {
              color: rgba(0, 0, 0, 0.45);
              transition: all 0.3s;
              &:not(:last-child) {
                margin-right: 40px;
              }
            }
          }
          .copyright {
            color: rgba(0, 0, 0, 0.45);
            font-size: 14px;
          }
        }
      }
    }
  </style>
